import { routeNames } from "@core/routeNames";

/** Legacy `/places?tabIndex=2` value for the Foods tab. Only the `/places` redirect still reads it. */
export const FOODS_TAB_INDEX = 2;

/** Query param that carries the active US Chains tab, e.g. `/chains?includes=bbq&tab=foods`. */
export const CHAINS_TAB_PARAM = "tab";
export const FOODS_TAB_PARAM_VALUE = "foods";

export type PlacesFoodsTab = "places" | "foods";

/**
 * Reads the `?tab` param. Anything other than `foods` — including an absent
 * param — is the Places tab, which is the US Chains default.
 */
export function parsePlacesFoodsTab(raw: string | null): PlacesFoodsTab {
    return raw === FOODS_TAB_PARAM_VALUE ? "foods" : "places";
}

/**
 * Builds the US Chains URL with the term seeded as an On the Menu include.
 * Pass `tab` to land on a specific tab; Places is the default and is left out
 * of the query so existing links stay byte-identical.
 */
export function buildFilteredChainsUrl(term: string, tab: PlacesFoodsTab = "places"): string {
    const trimmed = (term ?? "").trim();
    const params = new URLSearchParams();
    if (trimmed) params.set("includes", trimmed);
    if (tab === "foods") params.set(CHAINS_TAB_PARAM, FOODS_TAB_PARAM_VALUE);

    const query = params.toString();
    return query ? `${routeNames.chains}?${query}` : routeNames.chains;
}
